module.exports = __webpack_public_path__ + "img/1031.ec37e35b.gif";